import get from 'lodash.get';
import tracking from 'dibs-tracking';

function fireEcommerceImpressions(itemEdges, list) {
    tracking.trackEcommerce({
        type: 'productImpression',
        products: itemEdges.map((itemEdge, index) => ({
            list,
            position: index + 1,
            category: get(itemEdge, 'node.categoryPath'),
            ...get(itemEdge, 'node.ecommerceTrackingParams'),
        })),
    });
}

function fireEcommerceClick(index, itemEdge, list) {
    tracking.trackEcommerce({
        type: 'productClick',
        products: [
            {
                position: index + 1,
                category: get(itemEdge, 'node.categoryPath'),
                ...get(itemEdge, 'node.ecommerceTrackingParams'),
            },
        ],
        actionField: { list },
    });
}

/**
 * @see PdpRespSimilarItemsLanding.jsx
 */
const LANDING_ACTION = 'landing module clicked';
const LANDING_CATEGORY = 'landing module interaction';
const LANDING_LIST = 'pdp browse similar items';
const LANDING_LIST_SOLD = 'sold pdp browse similar items';

export function trackLandingItemImpressions(landingItems, isSoldPdp) {
    fireEcommerceImpressions(landingItems, isSoldPdp ? LANDING_LIST_SOLD : LANDING_LIST);
}

export function trackLandingItemClick(index, landingItem, isSoldPdp) {
    tracking.trackEvent({
        label: 'related items',
        action: LANDING_ACTION,
        category: LANDING_CATEGORY,
    });

    fireEcommerceClick(index, landingItem, isSoldPdp ? LANDING_LIST_SOLD : LANDING_LIST);
}

export function trackLandingViewAllClick() {
    tracking.trackEvent({
        label: 'related items view all',
        action: LANDING_ACTION,
        category: LANDING_CATEGORY,
    });
}

/**
 * @see PdpRespSimilarItemsGrid.jsx
 */
const SIMILAR_ITEMS_LIST = 'pdp you may also like';
export function trackSimilarItemImpressions(gridItems) {
    fireEcommerceImpressions(gridItems, SIMILAR_ITEMS_LIST);
}

export function trackSimilarItemClick(index, gridItem) {
    fireEcommerceClick(index, gridItem, SIMILAR_ITEMS_LIST);
}

/**
 * @see PdpRespSellerItemsGrid.jsx
 */
const SELLER_ITEMS_LIST = 'pdp more from dealer';
export function trackSellerItemImpressions(gridSellerItems) {
    fireEcommerceImpressions(gridSellerItems, SELLER_ITEMS_LIST);
}

export function trackSellerItemClick(index, gridSellerItem) {
    fireEcommerceClick(index, gridSellerItem, SELLER_ITEMS_LIST);
}

export function trackSellerPageClick() {
    tracking.trackEvent({
        action: 'click to seller page',
        category: 'dealer click',
        label: 'PDP',
    });
}

export function trackLandingItemsDisplayed() {
    tracking.trackEvent({
        action: 'landing module displayed',
        label: 'related items',
        category: LANDING_CATEGORY,
    });
}
